import React from 'react';
import Accordion from '@mui/material/Accordion';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ShippingDetails from 'components/ShippingDetails';
import {
  AccordionSummary,
  AccordionDetails,
  useStyles,
} from 'styles/pages/product-detail/accordion';

const ShippingCost = ({ data }) => {
  const classes = useStyles();

  return (
    <Accordion className={classes.accordion} defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography className={classes.heading}>
          Shipping costs (Expand for Total Price)
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ShippingDetails data={data} />
      </AccordionDetails>
    </Accordion>
  );
};

export default ShippingCost;
